import { type FC } from 'react'

export const SchedulingEmptyState: FC<{ title: string; subtitle: string }> = ({ title, subtitle }) => (
  <div className='d-flex flex-column align-items-center text-center py-5'>
    <div className='bold'>{title}</div>
    <div className='paragraph-small zocks-text-gray-600'>{subtitle}</div>
  </div>
)
